import {useTranslate} from '@tolgee/react'
import {Tooltip} from './tooltip'
import {PropsWithChildren} from 'react'

export function AvailableSoonTooltip({children}: PropsWithChildren) {
  const {t} = useTranslate('common')
  return <Tooltip content={t('available_soon')}>{children}</Tooltip>
}
